import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'offers'
const verb = 'post'

export default class OspreyOffersCreate extends BaseAction {
    constructor(dataKey) {
        const id = '4cdd0e45-673b-4386-8b6d-40e930065d30'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    create(params) {
        this.path = `/${resource}`
        this.params = params

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-create.js